import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgCheckmark = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 17 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="m14.854 4.854-8 8a.5.5 0 0 1-.707 0l-3.5-3.5a.5.5 0 1 1 .707-.708L6.5 11.793l7.647-7.647a.5.5 0 0 1 .707.708"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCheckmark);
export default ForwardRef;
